import React from 'react';

const FileTypeBadge = ({ fileType }) => {
  return (
    fileType ? (
      <span style={{ 
          border: '1px solid #333',
          borderRadius: '0px 8px',
          fontSize: '14px',
          padding: '2px 8px',
          marginRight: '5px',
          color: '#fff',
          backgroundColor: '#04697b'
      }}>
          {fileType}
      </span>
    ) : null
  );
};

export default FileTypeBadge;
